import { DatePivotParams } from "../../entities/date_pivot_params";
import dayjs from "../../utils/dayjs";

export const defaultConfig: DatePivotParams = {
  dateHierarchy: "week",
  measure: "",
  segments: [],
  minDate: dayjs.utc().subtract(6, "months").startOf("month").toDate(),
  maxDate: dayjs.utc().add(1, "month").startOf("month").toDate(),
  filters: [],
  postFilters: [],
};
